// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDNPkA3IH-BAtXvBSvB6Y1LFXG0NiiMPHU",
  authDomain: "tier-list-project.firebaseapp.com",
  projectId: "tier-list-project",
  storageBucket: "tier-list-project.appspot.com",
  messagingSenderId: "1003757994728",
  appId: "1:1003757994728:web:f1af839bc8200ac5277f5d",
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore();
